import { cn } from '@/lib/utils';
import { Dialog, DialogPanel } from '@headlessui/react';
import React from 'react';
import { Header, type HeaderProps } from './header';

interface Props {
    open: boolean;
    onClose: () => void;
    children: React.ReactNode;
}

export const Drawer = ({ open, onClose, children }: Props) => {
    return (
        <Dialog open={open ?? false} onClose={onClose} className="relative z-50 pointer-events-auto">
            <div className="fixed inset-0 flex w-screen items-center justify-end">
                <DialogPanel className="h-dvh max-h-dvh w-full sm:w-[80%] max-w-5xl space-y-4 overflow-auto border bg-white shadow-2xl">
                    {children}
                </DialogPanel>
            </div>
        </Dialog>
    );
};

export const DrawerContainer = ({ children, className }: React.PropsWithChildren<{ className?: string }>) => {
    return <div className={cn('flex w-full h-full flex-col bg-neutral-50', className)}>{children}</div>;
};

export const DrawerHeader = ({ className, ...props }: HeaderProps) => {
    return (
        <Header
            data-drawer-header
            className={cn('border-b border-neutral-200 bg-white px-4 py-3', className)}
            {...props}
        />
    );
};

export const DrawerContent = ({ className, children }: React.PropsWithChildren<{ className?: string }>) => {
    return (
        <div
            data-drawer-content
            className={cn('flex h-full grow flex-col gap-3 overflow-y-scroll px-4 py-3', className)}
        >
            {children}
        </div>
    );
};

export const DrawerFooter = ({ children }: React.PropsWithChildren) => {
    return (
        <div data-drawer-footer className="flex items-center justify-end px-4 py-3 bg-white border-t">
            {children}
        </div>
    );
};
